import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../base-modal/base-modal.component";
import {yandexDataCheckModalName} from "./configs/yandex-data-check-config";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {SiteClicksData, YandexDataCheckDialogData} from "./types/yandex-data-check.types";
import {YandexDataCheckService} from "./services/yandex-data-check.service";
import {MatButton} from "@angular/material/button";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {defaultSiteSlicksData} from "./configs/default-site-slicks-data";
import {LoaderComponent} from "../../../../shared/components/loader/loader.component";

@Component({
  selector: 'app-yandex-data-check-modal',
  imports: [
    BaseModalComponent,
    MatButton,
    MatFormField,
    MatLabel,
    MatInput,
    LoaderComponent
  ],
  templateUrl: './yandex-data-check-modal.component.html',
  styleUrl: './yandex-data-check-modal.component.scss'
})
export class YandexDataCheckModalComponent extends BaseModalComponent {
  private yandexDataCheckDialogData = inject<YandexDataCheckDialogData>(MAT_DIALOG_DATA);
  private yandexDataCheckService: YandexDataCheckService = inject(YandexDataCheckService);

  public siteClicksData: SiteClicksData = defaultSiteSlicksData;
  public isError: boolean = false;

  public override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    await this.initComponent();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(yandexDataCheckModalName);
  }

  public async handleUpdateYandexMetrics(): Promise<void> {
    const yandexMetricsParams = this.yandexDataCheckService.setYandexMetricsParams(this.yandexDataCheckDialogData);
    this.loadingService.setIsLoadingState(true);
    await this.yandexDataCheckService.updateYandexMetrics(yandexMetricsParams)
      .finally(() => this.loadingService.setIsLoadingState(false));
    this.closeDialog('cancel');
  }

  private async initComponent(): Promise<void> {
    this.modalStatesService.openModal(yandexDataCheckModalName);
    await this.getYandexMetrics();
  }

  private async getYandexMetrics(): Promise<void> {
    const yandexMetricsParams = this.yandexDataCheckService.setYandexMetricsParams(this.yandexDataCheckDialogData);
    this.loadingService.setIsLoadingState(true);
    this.siteClicksData = await this.yandexDataCheckService.getYandexMetrics(yandexMetricsParams)
      .catch(() => {
        this.isError = true;
        return defaultSiteSlicksData;
      })
      .finally(() => this.loadingService.setIsLoadingState(false));
  }
}
